import {
  ReactNode,
  useEffect,
  useState,
  useCallback,
} from "react";
import { onAuthStateChanged, signOut as firebaseSignOut, User } from "firebase/auth";
import { auth } from "../lib/firebase";
import { AuthContext } from "./AuthContext";
  

export function AuthProvider({ children }: { children: ReactNode }) {
    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | undefined>();
  
    useEffect(() => {
      return onAuthStateChanged(
        auth,
        (user) => {
          setUser(user);
          setIsLoading(false);
        },
        (err) => {
          setError(err);
          setIsLoading(false);
        }
      );
    }, []);
  
    const handleSignOut = useCallback(async () => {
      await firebaseSignOut(auth);
    }, []);
  
    const getAccessToken = useCallback(async () => {
      if (!auth.currentUser) return null;
      return auth.currentUser.getIdToken();
    }, []);
  
    return (
      <AuthContext.Provider
        value={{
          isAuthenticated: !!user,
          isLoading,
          user,
          error,
          signOut: handleSignOut,
          getAccessToken,
        }}
      >
        {children}
      </AuthContext.Provider>
    );
  }